import './App.css';
import Header from "./components/Header";

import AnimatedRoutes from './components/AnimatedRoutes';

function App() {
  return (
    <div className="App">
        <Header className="" />
        <AnimatedRoutes />
    </div>
  );
}

export default App;
